/**
 * EFKT-MOCK DOMAIN — see `./index.ts` banner comment. Mirrors datahub's `datahub/users/models.ts`.
 * Reuses `../branches/models::IBranch` rather than redeclaring one — the barrel re-exports every
 * domain's models flat, so a second `IBranch` would be a real compile error, not just noise.
 */
export var UserAccess;
(function (UserAccess) {
    UserAccess["None"] = "NONE";
    UserAccess["Regular"] = "REGULAR";
    UserAccess["Admin"] = "ADMIN";
})(UserAccess || (UserAccess = {}));
